import Vue from 'vue'

Vue.mixin({
    methods: {
        auctionStatusColor: function (status) {
            let color = 'success'
            switch (status.toUpperCase()) {
                case 'AUCTION':
                    color = 'success'
                    break;
                case 'PAUSE':
                    color = 'danger'
                    break;
                case 'WAITING':
                    color = 'warning'
                    break;
                case 'FINISHED':
                    color = 'dark'
                    break;
            }
            return color
        },
        setCountDown(datetime) {
            let diff = this.moment(datetime).diff(this.moment(), 'milliseconds')
            let time = ''
            if (diff > 0) {
                let d = Math.trunc(diff / 1000 / 3600 / 24);
                let h = Math.trunc(diff / 1000 / 3600) % 24;
                let m = Math.trunc(diff / 1000 / 60) % 60;
                let s = Math.trunc(diff / 1000) % 60
                time = `${(d > 0 ? d + 'Days' : '')} ${(h > 9 ? h : '0' + h)}:${(m > 9 ? m : '0' + m)}:${(s > 9 ? s : '0' + s)}`
            } else {
                time = `end`
            }
            return time
        },
        moneyFormat(bid) {
            return this.numeral(bid).format('0,0')
        },
        moneyFormatFull(bid) {
            if(bid)
                return this.numeral(bid).format('0,0.00')
            else
                 return '-'
        },
        numberTwoDigit(bid) {
            return this.numeral(bid).format('0,0.[00]')
        },
        timeFormat(datetime) {
            return this.$dayjs(datetime).format('YYYY-MM-DD HH:mm:ss');
        },
        dateFormat(datetime) {
            return this.$dayjs(datetime).format('YYYY-MM-DD');
        },
        dateTimeFormat(datetime, format) {
            return this.$dayjs(datetime).format(format);
        },
        dateThTimeFormat(datetime, format) {
            if (datetime) {
                this.$dayjs.locale('th');
                let dateFormated = this.$dayjs(datetime).add(543, 'year').format(format);
                this.$dayjs.locale('en');
                return dateFormated;
            } else
                return '';
        },
        checkShowMenu(roles) {
            let self = this;
            let result = roles.find((role) => {
                return role == self.$store.state.Admin.Role;
            })
            return (result ? true : false);
        },
        checkPermission(permissions) {
            let self = this;
            let result = permissions.filter(element => self.$store.state.Admin.Permission.includes(element));
            return (result.length > 0 ? true : false);
        },
        unitFormat(unit) {
            let unitText = 'ปี'
            switch (unit) {
                case 1:
                    unitText = 'วัน'
                    break;
                case 2:
                    unitText = 'เดือน'
                    break;
                case 3:
                    unitText = 'ปี'
                    break;
            }
            return unitText
        },
        getAllOrderStatus() {
            let allOrderStatus = [
                { id: 1, value: 'แจ้งงานใหม่' },
                { id: 2, value: 'แก้ไข/ขอข้อมูลเพิ่มเติม' },
                { id: 3, value: 'ส่งให้บริษัทประกัน' },
                { id: 4, value: 'รอนำส่ง บ.ประกัน' },
                { id: 5, value: 'ติดเมโม่' },
                { id: 6, value: 'ข้อเสนอใหม่ COF' },
                { id: 7, value: 'รอเอกสารจากสาขา' },
                { id: 8, value: 'กรมธรรม์อนุมัติ' },
                { id: 9, value: 'กรมธรรม์ไม่อนุมัติ' },
                { id: 10, value: 'ยกเลิกใบคำขอ' },
                { id: 11, value: 'ส่งงานและรอตรวจ' },
                { id: 12, value: 'ถูกบอกล้าง' },
                { id: 13, value: 'เวนคืนกรมธรรม์' },
                { id: 14, value: 'เปลี่ยนเป็นมูลค่าขยายเวลา' },
                { id: 15, value: 'เปลี่ยนเป็นมูลค่าใช้เงินสำเร็จ' },
                { id: 16, value: 'กรมธรรม์เกินกำหนด' },
                { id: 17, value: 'มรณกรรม' },
                { id: 18, value: 'เลื่อนการรับประกัน' },
                { id: 19, value: 'กรมธรรม์ขาดผลบังคับ' },
                { id: 20, value: 'ยกเลิกกรมธรรม์' },
                { id: 21, value: 'กรมธรรม์สัญญาสิ้นสุด' },
                { id: 22, value: 'ไม่ประสงค์ต่ออายุ' },
            ]
            return allOrderStatus;
        },
        getOrderStatus(status) {
            let allOrderStatus = this.getAllOrderStatus();
            let result = allOrderStatus.find((orderStatus) => {
                return orderStatus.id == status
            })
            return result.value;
        },
        getAllActionPhase() {
            let allActionPhase = [
                { id: 1, value: 'ไม่มี' },
                { id: 2, value: 'หน้าที่ผู้ลงข้อมูล/ผู้แจ้งงาน' },
                { id: 3, value: 'หน้าที่ผู้ตรวจสอบข้อมูล' },
                { id: 4, value: 'หน้าที่บริษัทประกัน' },
            ]
            return allActionPhase;
        },
        getActionPhase(action) {
            let allActionPhase = this.getAllActionPhase();
            let result = allActionPhase.find((actionPhase) => {
                return actionPhase.id == action
            })
            return result.value;
        },
        getInsuranceName(value) {
            //console.log('test',value)
            let found = this.InsuranceDatas.find(element => element.id == value);
            return found?.value
        },
        getCitizenIdPDPA(citizenId) {
            console.log('citizenID', citizenId)
            if (citizenId) {
                let formatedTxt = citizenId.substring(0, 2) + 'XXXXXXXXX' + citizenId.substring(citizenId.length, citizenId.length - 2);
                return formatedTxt;
            }
            else
                return '';
        },
        getFirst3Str(str) {
            //console.log('getFirst3', str)
            if (str) {
                let formatedTxt = str.substring(0, 3) + 'xxxxx';
                return formatedTxt;
            }
            else
                return '';
        },
        getFirst1Str(str) {
            //console.log('getFirst3', str)
            if (str) {
                let formatedTxt = str.substring(0, 1) + 'xxxxx';
                return formatedTxt;
            }
            else
                return '';
        },
    }
})
